/*=============================================== Colors dark ===============================================*/

import type { ColorType } from "./types"

export const colorsDark: ColorType[] = [
    {
        name: "Black",
        variable: "ThemeDark.Black",
        css: "var(--color-black)",
        hex: "#000000",
        rgb: "rgb(0, 0, 0)",
    },
    {
        name: "White",
        variable: "ThemeDark.White",
        css: "var(--color-white)",
        hex: "#FFFFFF",
        rgb: "rgb(255, 255, 255)",
    },
    {
        name: "Gray 50",
        variable: "ThemeDark.Gray50",
        css: "var(--color-dark-gray-50)",
        hex: "#181818",
        rgb: "rgb(24, 24, 24)",
    },
    {
        name: "Gray 100",
        variable: "ThemeDark.Gray100",
        css: "var(--color-dark-gray-100)",
        hex: "#2F2F2F",
        rgb: "rgb(47, 47, 47)",
    },
    {
        name: "Gray 200",
        variable: "ThemeDark.Gray200",
        css: "var(--color-dark-gray-200)",
        hex: "#474747",
        rgb: "rgb(71, 71, 71)",
    },
    {
        name: "Gray 300",
        variable: "ThemeDark.Gray300",
        css: "var(--color-dark-gray-300)",
        hex: "#5E5E5E",
        rgb: "rgb(94, 94, 94)",
    },
    {
        name: "Gray 400",
        variable: "ThemeDark.Gray400",
        css: "var(--color-dark-gray-400)",
        hex: "#767676",
        rgb: "rgb(118, 118, 118)",
    },
    {
        name: "Gray 500",
        variable: "ThemeDark.Gray500",
        css: "var(--color-dark-gray-500)",
        hex: "#919191",
        rgb: "rgb(145, 145, 145)",
    },
    {
        name: "Gray 600",
        variable: "ThemeDark.Gray600",
        css: "var(--color-dark-gray-600)",
        hex: "#ADADAD",
        rgb: "rgb(173, 173, 173)",
    },
    {
        name: "Gray 700",
        variable: "ThemeDark.Gray700",
        css: "var(--color-dark-gray-700)",
        hex: "#C8C8C8",
        rgb: "rgb(200, 200, 200)",
    },
    {
        name: "Gray 800",
        variable: "ThemeDark.Gray800",
        css: "var(--color-dark-gray-800)",
        hex: "#E4E4E4",
        rgb: "rgb(228, 228, 228)",
    },
    {
        name: "Gray 900",
        variable: "ThemeDark.Gray900",
        css: "var(--color-dark-gray-900)",
        hex: "#F8F8F8",
        rgb: "rgb(248, 248, 248)",
    },
    {
        name: "Primary 50",
        variable: "ThemeDark.Primary50",
        css: "var(--color-dark-primary-50)",
        hex: "#141E33",
        rgb: "rgb(20, 30, 51)",
    },
    {
        name: "Primary 100",
        variable: "ThemeDark.Primary100",
        css: "var(--color-dark-primary-100)",
        hex: "#293D66",
        rgb: "rgb(41, 61, 102)",
    },
    {
        name: "Primary 200",
        variable: "ThemeDark.Primary200",
        css: "var(--color-dark-primary-200)",
        hex: "#3D5B99",
        rgb: "rgb(61, 91, 153)",
    },
    {
        name: "Primary 300",
        variable: "ThemeDark.Primary300",
        css: "var(--color-dark-primary-300)",
        hex: "#527ACC",
        rgb: "rgb(82, 122, 204)",
    },
    {
        name: "Primary 400",
        variable: "ThemeDark.Primary400",
        css: "var(--color-dark-primary-400)",
        hex: "#6698FF",
        rgb: "rgb(102, 152, 255)",
    },
    {
        name: "Primary 500",
        variable: "ThemeDark.Primary500",
        css: "var(--color-dark-primary-500)",
        hex: "#85ADFF",
        rgb: "rgb(133, 173, 255)",
    },
    {
        name: "Primary 600",
        variable: "ThemeDark.Primary600",
        css: "var(--color-dark-primary-600)",
        hex: "#A3C1FF",
        rgb: "rgb(163, 193, 255)",
    },
    {
        name: "Primary 700",
        variable: "ThemeDark.Primary700",
        css: "var(--color-dark-primary-700)",
        hex: "#C2D6FF",
        rgb: "rgb(194, 214, 255)",
    },
    {
        name: "Primary 800",
        variable: "ThemeDark.Primary800",
        css: "var(--color-dark-primary-800)",
        hex: "#E0EAFF",
        rgb: "rgb(224, 234, 255)",
    },
    {
        name: "Primary 900",
        variable: "ThemeDark.Primary900",
        css: "var(--color-dark-primary-900)",
        hex: "#F7FAFF",
        rgb: "rgb(247, 250, 255)",
    },
    {
        name: "Secondary 50",
        variable: "ThemeDark.Secondary50",
        css: "var(--color-dark-secondary-50)",
        hex: "#172D2E",
        rgb: "rgb(23, 45, 46)",
    },
    {
        name: "Secondary 100",
        variable: "ThemeDark.Secondary100",
        css: "var(--color-dark-secondary-100)",
        hex: "#2E595C",
        rgb: "rgb(46, 89, 92)",
    },
    {
        name: "Secondary 200",
        variable: "ThemeDark.Secondary200",
        css: "var(--color-dark-secondary-200)",
        hex: "#44868B",
        rgb: "rgb(68, 134, 139)",
    },
    {
        name: "Secondary 300",
        variable: "ThemeDark.Secondary300",
        css: "var(--color-dark-secondary-300)",
        hex: "#5BB2B9",
        rgb: "rgb(91, 178, 185)",
    },
    {
        name: "Secondary 400",
        variable: "ThemeDark.Secondary400",
        css: "var(--color-dark-secondary-400)",
        hex: "#72DFE7",
        rgb: "rgb(114, 223, 231)",
    },
    {
        name: "Secondary 500",
        variable: "ThemeDark.Secondary500",
        css: "var(--color-dark-secondary-500)",
        hex: "#8EE5EC",
        rgb: "rgb(142, 229, 236)",
    },
    {
        name: "Secondary 600",
        variable: "ThemeDark.Secondary600",
        css: "var(--color-dark-secondary-600)",
        hex: "#AAECF1",
        rgb: "rgb(170, 236, 241)",
    },
    {
        name: "Secondary 700",
        variable: "ThemeDark.Secondary700",
        css: "var(--color-dark-secondary-700)",
        hex: "#C7F2F5",
        rgb: "rgb(199, 242, 245)",
    },
    {
        name: "Secondary 800",
        variable: "ThemeDark.Secondary800",
        css: "var(--color-dark-secondary-800)",
        hex: "#E3F9FA",
        rgb: "rgb(227, 249, 250)",
    },
    {
        name: "Secondary 900",
        variable: "ThemeDark.Secondary900",
        css: "var(--color-dark-secondary-900)",
        hex: "#F8FEFE",
        rgb: "rgb(248, 254, 254)",
    },
    {
        name: "Success 50",
        variable: "ThemeDark.Success50",
        css: "var(--color-dark-success-50)",
        hex: "#112F20",
        rgb: "rgb(17, 47, 32)",
    },
    {
        name: "Success 100",
        variable: "ThemeDark.Success100",
        css: "var(--color-dark-success-100)",
        hex: "#235E40",
        rgb: "rgb(35, 94, 64)",
    },
    {
        name: "Success 200",
        variable: "ThemeDark.Success200",
        css: "var(--color-dark-success-200)",
        hex: "#348D61",
        rgb: "rgb(52, 141, 97)",
    },
    {
        name: "Success 300",
        variable: "ThemeDark.Success300",
        css: "var(--color-dark-success-300)",
        hex: "#46BC81",
        rgb: "rgb(70, 188, 129)",
    },
    {
        name: "Success 400",
        variable: "ThemeDark.Success400",
        css: "var(--color-dark-success-400)",
        hex: "#57EBA1",
        rgb: "rgb(87, 235, 161)",
    },
    {
        name: "Success 500",
        variable: "ThemeDark.Success500",
        css: "var(--color-dark-success-500)",
        hex: "#79EFB4",
        rgb: "rgb(121, 239, 180)",
    },
    {
        name: "Success 600",
        variable: "ThemeDark.Success600",
        css: "var(--color-dark-success-600)",
        hex: "#9AF3C7",
        rgb: "rgb(154, 243, 199)",
    },
    {
        name: "Success 700",
        variable: "ThemeDark.Success700",
        css: "var(--color-dark-success-700)",
        hex: "#BCF7D9",
        rgb: "rgb(188, 247, 217)",
    },
    {
        name: "Success 800",
        variable: "ThemeDark.Success800",
        css: "var(--color-dark-success-800)",
        hex: "#DDFBEC",
        rgb: "rgb(221, 251, 236)",
    },
    {
        name: "Success 900",
        variable: "ThemeDark.Success900",
        css: "var(--color-dark-success-900)",
        hex: "#F7FEFA",
        rgb: "rgb(247, 254, 250)",
    },
    {
        name: "Danger 50",
        variable: "ThemeDark.Danger50",
        css: "var(--color-dark-danger-50)",
        hex: "#331A1A",
        rgb: "rgb(51, 26, 26)",
    },
    {
        name: "Danger 100",
        variable: "ThemeDark.Danger100",
        css: "var(--color-dark-danger-100)",
        hex: "#663333",
        rgb: "rgb(102, 51, 51)",
    },
    {
        name: "Danger 200",
        variable: "ThemeDark.Danger200",
        css: "var(--color-dark-danger-200)",
        hex: "#994D4D",
        rgb: "rgb(153, 77, 77)",
    },
    {
        name: "Danger 300",
        variable: "ThemeDark.Danger300",
        css: "var(--color-dark-danger-300)",
        hex: "#CC6666",
        rgb: "rgb(204, 102, 102)",
    },
    {
        name: "Danger 400",
        variable: "ThemeDark.Danger400",
        css: "var(--color-dark-danger-400)",
        hex: "#FF8080",
        rgb: "rgb(255, 128, 128)",
    },
    {
        name: "Danger 500",
        variable: "ThemeDark.Danger500",
        css: "var(--color-dark-danger-500)",
        hex: "#FF9999",
        rgb: "rgb(255, 153, 153)",
    },
    {
        name: "Danger 600",
        variable: "ThemeDark.Danger600",
        css: "var(--color-dark-danger-600)",
        hex: "#FFB3B3",
        rgb: "rgb(255, 179, 179)",
    },
    {
        name: "Danger 700",
        variable: "ThemeDark.Danger700",
        css: "var(--color-dark-danger-700)",
        hex: "#FFCCCC",
        rgb: "rgb(255, 204, 204)",
    },
    {
        name: "Danger 800",
        variable: "ThemeDark.Danger800",
        css: "var(--color-dark-danger-800)",
        hex: "#FFE6E6",
        rgb: "rgb(255, 230, 230)",
    },
    {
        name: "Danger 900",
        variable: "ThemeDark.Danger900",
        css: "var(--color-dark-danger-900)",
        hex: "#FFF9F9",
        rgb: "rgb(255, 249, 249)",
    },
    {
        name: "Warning 50",
        variable: "ThemeDark.Warning50",
        css: "var(--color-dark-warning-50)",
        hex: "#332917",
        rgb: "rgb(51, 41, 23)",
    },
    {
        name: "Warning 100",
        variable: "ThemeDark.Warning100",
        css: "var(--color-dark-warning-100)",
        hex: "#65522E",
        rgb: "rgb(101, 82, 46)",
    },
    {
        name: "Warning 200",
        variable: "ThemeDark.Warning200",
        css: "var(--color-dark-warning-200)",
        hex: "#987A46",
        rgb: "rgb(152, 122, 70)",
    },
    {
        name: "Warning 300",
        variable: "ThemeDark.Warning300",
        css: "var(--color-dark-warning-300)",
        hex: "#CAA35D",
        rgb: "rgb(202, 163, 93)",
    },
    {
        name: "Warning 400",
        variable: "ThemeDark.Warning400",
        css: "var(--color-dark-warning-400)",
        hex: "#FDCC74",
        rgb: "rgb(253, 204, 116)",
    },
    {
        name: "Warning 500",
        variable: "ThemeDark.Warning500",
        css: "var(--color-dark-warning-500)",
        hex: "#FED690",
        rgb: "rgb(254, 214, 144)",
    },
    {
        name: "Warning 600",
        variable: "ThemeDark.Warning600",
        css: "var(--color-dark-warning-600)",
        hex: "#FEE0AC",
        rgb: "rgb(254, 224, 172)",
    },
    {
        name: "Warning 700",
        variable: "ThemeDark.Warning700",
        css: "var(--color-dark-warning-700)",
        hex: "#FEEBC7",
        rgb: "rgb(254, 235, 199)",
    },
    {
        name: "Warning 800",
        variable: "ThemeDark.Warning800",
        css: "var(--color-dark-warning-800)",
        hex: "#FFF5E3",
        rgb: "rgb(255, 245, 227)",
    },
    {
        name: "Warning 900",
        variable: "ThemeDark.Warning900",
        css: "var(--color-dark-warning-900)",
        hex: "#FFFDF8",
        rgb: "rgb(255, 253, 248)",
    },
    {
        name: "Background",
        variable: "ThemeDark.Background",
        css: "var(--color-dark-background)",
        hex: "#0E1116",
        rgb: "rgb(18, 18, 18)",
    },
    {
        name: "Font",
        variable: "ThemeDark.Font",
        css: "var(--color-dark-font)",
        hex: "#FFFFFF",
        rgb: "rgb(255, 255, 255)",
    },
    {
        name: "LinkFontDefault",
        variable: "ThemeDark.LinkFontDefault",
        css: "var(--color-dark-link-font-default)",
        hex: "#FFFFFF",
        rgb: "rgb(255, 255, 255)",
    },
    {
        name: "LinkFontHover",
        variable: "ThemeDark.LinkFontHover",
        css: "var(--color-dark-link-font-hover)",
        hex: "#5E5E5E",
        rgb: "rgb(94, 94, 94)",
    },
    {
        name: "LinkFontActive",
        variable: "ThemeDark.LinkFontActive",
        css: "var(--color-dark-link-font-active)",
        hex: "#2F2F2F",
        rgb: "rgb(47, 47, 47)",
    },
    {
        name: "LinkBackgroundDefault",
        variable: "ThemeDark.LinkBackgroundDefault",
        css: "var(--color-dark-link-background-default)",
        hex: "#0E1116",
        rgb: "rgb(18, 18, 18)",
    },
    {
        name: "LinkBackgroundHover",
        variable: "ThemeDark.LinkBackgroundHover",
        css: "var(--color-dark-link-background-hover)",
        hex: "#C8C8C8",
        rgb: "rgb(200, 200, 200)",
    },
    {
        name: "LinkBackgroundActive",
        variable: "ThemeDark.LinkBackgroundActive",
        css: "var(--color-dark-link-background-active)",
        hex: "#F8F8F8",
        rgb: "rgb(248, 248, 248)",
    },
]
